export default function splitCamelCase(word) {
	let str = word.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
	return str[0].toUpperCase() + str.substring(1);
}
